export const imageTypes = /jpeg|jpg|png|gif|heic|octet-stream/;
export const lengthImageComments =  10